import { RectangleStackIcon } from '@heroicons/vue/20/solid';

const mainSidebarConfig = [
  {
    title: 'Websites',
    icon: RectangleStackIcon,
    path: '/websites/',
    website: false,
  },
];

export { mainSidebarConfig };
